
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".search-box-naf input[type='search']").forEach(function (searchInput) {
        const inputId = searchInput.getAttribute("id");
        const uniqueId = inputId.replace("Search-In-Modal-", "");
        const resultsContainer = document.getElementById("predictive-search-results-" + uniqueId);

        searchInput.addEventListener("input", function () {
            let searchTerm = searchInput.value.trim();
            if (searchTerm.length > 2) {
                fetch(`/search/suggest.json?q=${searchTerm}&resources[type]=product`)
                    .then(response => response.json())
                    .then(data => {
                        let resultsHTML = "";
                        data.resources.results.products.forEach(product => {
                            resultsHTML += `<div class="search-suggestion">
                                <a href="${product.url}">
                                    <img src="${product.image}" alt="${product.title}" width="50">
                                    <span>${product.title}</span>
                                </a>
                            </div>`;
                        });
                        resultsContainer.innerHTML = resultsHTML;
                        resultsContainer.style.display = "block";
                    })
                    .catch(error => console.error("Search API Error:", error));
            } else {
                resultsContainer.innerHTML = "";
                resultsContainer.style.display = "none";
            }
        });

        document.addEventListener("click", function (e) {
            if (!searchInput.contains(e.target) && !resultsContainer.contains(e.target)) {
                resultsContainer.style.display = "none";
            }
        });
    });
});



// document.addEventListener("DOMContentLoaded", function () {

//     document.querySelectorAll(".search-box-naf input[type='search']").forEach(function (searchInput) {

//         const inputId = searchInput.getAttribute("id");
//         const uniqueId = inputId.replace("Search-In-Modal-", "");
//         const resultsContainer = document.getElementById("predictive-search-results-" + uniqueId);

//         let exactMatchURL = null;

//         searchInput.addEventListener("input", function () {

//             let searchTerm = searchInput.value.trim().toLowerCase();

//             // Remove special characters and spaces for accurate matching
//             let cleanTerm = searchTerm.replace(/[^a-z0-9]/gi, "");

//             // Show only after 3 characters
//             if (cleanTerm.length > 2) {

//                 fetch(`/search/suggest.json?q=${cleanTerm}&resources[type]=product`)
//                     .then(response => response.json())
//                     .then(data => {

//                         let products = data.resources.results.products || [];
//                         let resultsHTML = "";

//                         // STRICT MATCH FILTER
//                         let strictMatches = products.filter(p => {
//                             let title = p.title.toLowerCase().replace(/[^a-z0-9]/gi, "");
//                             return (
//                                 title.startsWith(cleanTerm) ||   // starts with match
//                                 title.includes(cleanTerm)        // contains match
//                             );
//                         });

//                         // No strict matches → hide dropdown
//                         if (strictMatches.length === 0) {
//                             resultsContainer.innerHTML = "";
//                             resultsContainer.style.display = "none";
//                             exactMatchURL = null;
//                             return;
//                         }

//                         // Only 1 perfect match → allow redirect
//                         exactMatchURL = strictMatches.length === 1 ? strictMatches[0].url : null;

//                         // Build dropdown HTML
//                         strictMatches.forEach(product => {
//                             resultsHTML += `
//                                 <div class="search-suggestion">
//                                     <a href="${product.url}">
//                                         <img src="${product.image}" alt="${product.title}" width="50">
//                                         <span>${product.title}</span>
//                                     </a>
//                                 </div>
//                             `;
//                         });

//                         resultsContainer.innerHTML = resultsHTML;
//                         resultsContainer.style.display = "block";

//                     })
//                     .catch(error => console.error("Search API Error:", error));

//             } else {
//                 // Clear dropdown when input is short
//                 resultsContainer.innerHTML = "";
//                 resultsContainer.style.display = "none";
//                 exactMatchURL = null;
//             }
//         });

//         // ENTER → strict search redirect
//         searchInput.addEventListener("keydown", function (e) {
//             if (e.key === "Enter") {
//                 e.preventDefault();

//                 let cleanTerm = searchInput.value
//                     .trim()
//                     .toLowerCase()
//                     .replace(/[^a-z0-9]/gi, "");

//                 if (cleanTerm.length > 0) {
//                     window.location.href = `/search?q=title:*${cleanTerm}*&type=product`;
//                 }
//             }
//         });

//         // Hide dropdown on outside click
//         document.addEventListener("click", function (e) {
//             if (!searchInput.contains(e.target) && !resultsContainer.contains(e.target)) {
//                 resultsContainer.style.display = "none";
//             }
//         });

//     });
// });


// document.addEventListener("DOMContentLoaded", function () {

//     /* --------------------------------------------------
//        1) Predictive Suggestions (Unchanged)
//     -------------------------------------------------- */
//     document.querySelectorAll(".search-box-naf input[type='search']").forEach(function (searchInput) {

//         const inputId = searchInput.getAttribute("id");
//         const uniqueId = inputId.replace("Search-In-Modal-", "");
//         const resultsContainer = document.getElementById("predictive-search-results-" + uniqueId);

//         searchInput.addEventListener("input", function () {
//             let searchTerm = searchInput.value.trim();

//             if (searchTerm.length > 2) {
//                 fetch(`/search/suggest.json?q=${searchTerm}&resources[type]=product`)
//                     .then(response => response.json())
//                     .then(data => {

//                         let resultsHTML = "";
//                         data.resources.results.products.forEach(product => {
//                             resultsHTML += `
//                                 <div class="search-suggestion">
//                                     <a href="${product.url}">
//                                         <img src="${product.image}" width="50" alt="${product.title}">
//                                         <span>${product.title}</span>
//                                     </a>
//                                 </div>`;
//                         });

//                         resultsContainer.innerHTML = resultsHTML;
//                         resultsContainer.style.display = "block";
//                     })
//                     .catch(error => console.error("Search API Error:", error));

//             } else {
//                 resultsContainer.innerHTML = "";
//                 resultsContainer.style.display = "none";
//             }
//         });

//         document.addEventListener("click", function (e) {
//             if (!searchInput.contains(e.target) && !resultsContainer.contains(e.target)) {
//                 resultsContainer.style.display = "none";
//             }
//         });
//     });



//     /* --------------------------------------------------
//        2) MODEL NUMBER + PURE SKU NUMBER Search Redirect
//     -------------------------------------------------- */
//     const searchForms = document.querySelectorAll('form[action="/search"], form[method="get"]');

//     searchForms.forEach(function (form) {

//         form.addEventListener("submit", function (e) {

//             const input = form.querySelector('input[name="q"]');
//             if (!input) return;

//             let value = input.value.trim();

//             // 1) Format like CB5004-59W or NB6004-83E
//             const modelPattern = /^[A-Za-z0-9]+[-–][A-Za-z0-9]+$/;

//             // 2) Format like R27073722 (No dash, 6–12 chars)
//             const pureSKUPattern = /^[A-Za-z0-9]{6,12}$/;

//             if (modelPattern.test(value) || pureSKUPattern.test(value)) {

//                 e.preventDefault();

//                 // Wildcard SKU for both types
//                 const wildcardQuery = encodeURIComponent(`variants.sku:*${value}*`);

//                 const finalURL = "/search?type=product&q=" + wildcardQuery;

//                 window.location.href = finalURL;
//             }
//         });
//     });

// });

